import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export interface ConfidentialPayloadFields {
  discount?: string;
  promoCode?: string;
  instruction?: string;
}

export interface ConfidentialRelease {
  id: string;
  batchId: string;
  version: number;
  notes?: string | null;
  issuedAt: string;
  validUntil: string;
  supersededAt?: string | null;
  revokedAt?: string | null;
  status: 'active' | 'expired' | 'revoked';
  retailerPayload: ConfidentialPayloadFields;
  dealerPayload?: ConfidentialPayloadFields;
}

export interface ConfidentialSubscriptionStatus {
  active: boolean;
  status?: string | null;
  validUntil?: string | null;
}

class ConfidentialService {
  private getAuthHeader() {
    const token = localStorage.getItem('auth_token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getBatchReleases(batchId: string): Promise<{
    subscription: ConfidentialSubscriptionStatus;
    latest: ConfidentialRelease | null;
    releases: ConfidentialRelease[];
  }> {
    const response = await axios.get(
      `${API_URL}/confidential/batch/${batchId}/releases`,
      this.getAuthHeader()
    );
    return response.data;
  }

  async createRelease(
    batchId: string,
    payload: {
      retailer: ConfidentialPayloadFields;
      dealer?: ConfidentialPayloadFields;
      notes?: string;
      validUntil?: string;
    }
  ): Promise<{ release: ConfidentialRelease }> {
    const response = await axios.post(
      `${API_URL}/confidential/batch/${batchId}/releases`,
      payload,
      this.getAuthHeader()
    );
    return response.data;
  }

  async revokeRelease(
    batchId: string,
    releaseId: string
  ): Promise<{ release: ConfidentialRelease }> {
    const response = await axios.post(
      `${API_URL}/confidential/batch/${batchId}/releases/${releaseId}/revoke`,
      {},
      this.getAuthHeader()
    );
    return response.data;
  }
}

export const confidentialService = new ConfidentialService();
